export default {
  ID: 'id',
  CODE: 'aibCode',
  ENGLISH: 'enName',
  ESTONIAN: 'etName',
  LANG: 'lang',
  COUNTRY_CODE: 'countryCode',
  MEMBER_CODE: 'memberCode',
  ACTIVE: 'active',
};
